var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcLogoApple = function SvgIcLogoApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.437 6.423c.767 0 1.729-.519 2.302-1.21.518-.627.896-1.503.896-2.378 0-.119-.01-.238-.032-.335-.854.032-1.88.573-2.496 1.297-.487.551-.93 1.416-.93 2.302 0 .13.022.26.033.302.054.011.14.022.226.022M9.735 19.5c1.048 0 1.513-.703 2.82-.703 1.33 0 1.622.681 2.789.681 1.145 0 1.913-1.059 2.637-2.096.81-1.19 1.145-2.356 1.167-2.41-.076-.022-2.27-.919-2.27-3.437 0-2.183 1.73-3.167 1.827-3.242-1.146-1.643-2.886-1.686-3.361-1.686-1.286 0-2.335.778-2.994.778-.713 0-1.653-.735-2.767-.735-2.118 0-4.269 1.75-4.269 5.058 0 2.053.8 4.226 1.784 5.63.843 1.19 1.578 2.162 2.637 2.162"
  })));
};
export default SvgIcLogoApple;